<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="Date" [matDatepicker]="pickerFrom" placeholder="Fecha">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="full-width">
        <mat-select placeholder="Equipos" formControlName="Equipments" multiple>
            <mat-select-trigger>
                {{f.Equipments.value?.length > 0 ? f.Equipments.value[0].Name : ''}}
                <span *ngIf="f.Equipments.value?.length > 1" class="additional-selection">
                  (+{{f.Equipments.value.length - 1}} {{f.Equipments.value?.length === 2 ? 'otra' : 'otras'}})
                </span>
            </mat-select-trigger>
            <mat-option *ngFor="let equipmentFilter of equipmentFilters" [value]="equipmentFilter">
                {{equipmentFilter.Name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width">
        <input type="text" #referringPhysician matInput placeholder="Centro" formControlName="Center" [matAutocomplete]="autCenter">
        <mat-autocomplete #autCenter="matAutocomplete" [displayWith]="filterCompleteCenters.displayFn">
            <mat-option *ngFor="let center of filteredCentersOptions | async" [value]="center">
                {{center.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <div class="full-width">
        <patient-autocomplete formControlName="Patient"></patient-autocomplete>
    </div>
    <mat-checkbox formControlName="ViewAttended">Ver atendidos</mat-checkbox>
    <mat-checkbox *ngIf="viewMyStudies" formControlName="ViewMyStudies">Ver mis estudios</mat-checkbox>
</form>